import * as types from "./loginActionTypes";
import * as dataActionTypes from "../../utils/data/dataActionTypes";
import * as loginUtils from "./loginUtils";

export default function loginReducer(state = {}, action) {
  switch (action.type) {
    case dataActionTypes.UPDATE_DATA_ITEM_SUCCESS: {
      let user = action.payload.data;
      if (user.userId == state.user.userId) {
        // In case the user modified is the user logged in, building relationships with data returned by API to keep it synchronized with backend
        const role = {
          "id": "role_id",
          "object": user.role,
        };
        const associatedBu = {
          "id": "account_business_unit_id",
          "object": user.associatedBu.map((bu) => ({"accountBusinessUnitId": bu, "userId": user.userId})),
        };
        user = {...user, "relationships": {associatedBu, role}};
        delete user.associatedBu;
        delete user.role;
        return {
          ...state,
          user,
        };
      }
      return state;
    }
    case types.CHANGE_PASSWORD: {
      return {
        ...state,
        requestingChange: true,
      };
    }
    case types.CHANGE_PASSWORD_FAILURE:
    case types.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        requestingChange: false,
      };
    }
    case types.LOGIN: {
      return {
        ...state,
        isFetching: true,
        isVerifying: action.isVerifying,
      };
    }
    case types.LOGIN_SUCCESS: {
      if (action.payload.data.passwordExpired)
        return { passwordExpired: true };
      return {
        user: action.payload.data.user,
        accessToken: action.payload.data.accessToken,
        lastAuth: loginUtils.getIssuedAtFromAccessToken(
          action.payload.data.accessToken
        ),
      };
    }
    case types.LOGIN_FAILURE: {
      return {
        lastAuth: new Date(),
        error: action.payload.error,
      };
    }
    case types.LOGIN_CLEAR_ERRORS: {
      return {
        ...state,
        error: false,
      };
    }
    case types.LOGOUT: {
      return {};
    }
    case types.RESET_PASSWORD: {
      return {
        ...state,
        message: "processing...",
        error: false,
        isFetching: true,
      };
    }
    case types.RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        message: "password_reset_success",
        error: false,
        isFetching: false,
      };
    }
    case types.RESET_PASSWORD_FAILURE: {
      return {
        ...state,
        error: {
          data: {
            error: "resetFailed",
          },
        },
        errorType: action.payload.error.data.error,
        message: action.payload.error.data.message[0],
        isFetching: false,
      };
    }
    case types.VALIDATE_TOKEN: {
      return {
        ...state,
        error: false,
      };
    }
    case types.VALIDATE_TOKEN_SUCCESS: {
      return {
        ...state,
      };
    }
    case types.VALIDATE_TOKEN_FAILURE: {
      return {
        ...state,
        error: {
          data: {
            error: "invalidToken",
          },
        },
      };
    }
    case types.INITIATE_PASSWORD_RESET: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/login/loginReducer.js